import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, switchMap, tap } from 'rxjs/operators';
import { MessageService } from '../services/message.service';
import { of } from 'rxjs';
import {
  addAProduct,
  addAProductSuccess,
  deleteAProduct,
  deleteAProductSuccess,
  deleteMeeting,
  deleteMeetingSuccess,
  refreshMeeting,
  restoreMeeting,
  restoreMeetingSuccess,
  updateAProduct,
  updateAProductError,
  updateAProductSuccess,
  updateLeftMenuCount,
  updateLeftMenuCountError,
  updateLeftMenuCountSuccess,
  updateMeeting,
  updateMeetingSuccess,
  viewMeeting,
  viewMeetingSuccess,
} from '../actions/meeting.action';
import { Store } from '@ngrx/store';
import { IReducers } from '../reducers';

@Injectable()
export class MeetingEffect {
  viewMeeting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(viewMeeting),
      exhaustMap(action => this.messageService.viewMeeting(action.id_meeting)),
      map(res => viewMeetingSuccess({ data: res })),
    ),
  );

  updateMeeting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateMeeting),
      exhaustMap(action => this.messageService.updateMeeting(action.meeting)),
      map(res => updateMeetingSuccess({ response: res })),
    ),
  );

  refreshMeeting = createEffect(() =>
    this.actions$.pipe(
      ofType(refreshMeeting),
      switchMap(action =>
        of(
          viewMeeting({
            id_meeting: action.id_meeting,
          }),
        ),
      ),
    ),
  );

  deleteMeeting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteMeeting),
      exhaustMap(action =>
        this.messageService.deleteMeeting(action.id_meeting),
      ),
      map(res => deleteMeetingSuccess({ response: res })),
    ),
  );

  restoreMeeting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(restoreMeeting),
      exhaustMap(action =>
        this.messageService.restoreMeeting(action.id_meeting),
      ),
      map(res => restoreMeetingSuccess({ response: res })),
    ),
  );

  addAProduct = createEffect(() =>
    this.actions$.pipe(
      ofType(addAProduct),
      exhaustMap(action =>
        this.messageService.addProduct(action.meeting, action.product),
      ),
      map(res => addAProductSuccess({ response: res })),
    ),
  );

  updateAProduct = createEffect(() =>
    this.actions$.pipe(
      ofType(updateAProduct),
      switchMap(action =>
        this.messageService.updateProduct(action.meeting, action.product)
          .pipe(
            map(ac => updateAProductSuccess({ id_meeting: action.meeting.meeting_id })),
            catchError(err => of(updateAProductError(err))),
          ),
    ),
  ));

  updateProductSuccess = createEffect(() =>
    this.actions$.pipe(
      ofType(updateAProductSuccess),
      map((res) => viewMeeting({ id_meeting: res.id_meeting })),
    ),
  );

  deleteAProduct = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteAProduct),
      exhaustMap(action =>
        this.messageService.deleteProduct(action.meeting, action.product).pipe(
          tap(response =>
            this.store$.dispatch(
              refreshMeeting({
                id_meeting: action.meeting.meeting_id,
              }),
            ),
          ),
          map(res => deleteAProductSuccess({ response: res })),
        ),
      ),
    ),
  );

  updateLeftMenuCount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateLeftMenuCount),
      switchMap(action =>
        this.messageService.getInboxCount().pipe(
          map(res => updateLeftMenuCountSuccess({ response: res })),
          catchError(error => of(updateLeftMenuCountError(error))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private store$: Store<IReducers>,
    private messageService: MessageService,
  ) {
  }
}
